<template>
    <div class="main-div p-20 shadow rounded">
        <div class="row">
            <div class="col-9">
                <h2>Detail SJ</h2>
            </div>
            <div class="col-3 text-right">
                <button class="btn btn-secondary" @click="$emit('closeModal')">X Close</button>
            </div>
        </div>
        <!-- {{data}} -->

        <div style="overflow-y:scroll;height:85%">
            <table v-if="data" class="table table-striped mt-3">
                <thead>
                    <th>Nopol</th>
                    <th class="text-center"><i class="fa fa-cog"></i></th>

                </thead>
                <tbody >
                    <tr v-for="index in data" :key="'Pengiriman Barang' + index">
                        <td>{{nopol}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>

<script>
    // import moment from 'moment'

    export default {
        data() {
            return {
                dataReady : false,
                data : null,
                filter : null,
                modal : false,
                editData : null
            }
        },
        props : [
            'edit_data',
            'api_edit',
            'api_get',
            'form_type'
        ],
        components: {
        },
        mounted() {

            this.filter = JSON.parse(this.edit_data)
            this.getDetails()
        },
        watch: {
            edit_data : {
                deep : true,
                handler () {
                    console.log('data changed')
                    this.filter = JSON.parse(this.edit_data)
                    this.getDetails()
                }
            }
        },
        methods: {
            async getDetails () {
                try {
                    let url = `${this.api_get}?ekspedisi=${this.filter.ekspedisi}`

                    let response = await this.$http.get(url)

                    this.data = response.data.data

                    this.dataReady = true

                }
                catch(err) {
                    console.log(err)
                }
            }
            
        }
    }
</script>

<style scoped>
    * {
        font: normal normal normal Poppins;
    }

    @media screen and (min-width: 800px) {
        .main-div {
            position:fixed;
            bottom:4.5vh;
            height:350px;
            background-color:white;
            width:calc(100% - 320px);
        }
    }

    @media screen and (max-width: 800px) {
        .main-div {
            position:fixed;
            bottom:4.5vh;
            height:250px;
            background-color:white;
            width:80%;
        }
    }

    td {
        vertical-align: center !important;
    }
    
</style>